import { border as border$1, borderRadius as borderRadius$1, color as color$1, compose as compose$1, flexbox as flexbox$1, grid as grid$1, gridColumn as gridColumn$1, layout as layout$1, shadow as shadow$1, space as space$1, typography as typography$1, style as style$1, system as system$1 } from 'styled-system';
import { css as css$1 } from '@styled-system/css';
import { useContext } from 'react';
import * as styledComponents from 'styled-components';
var _ref = styledComponents,
    styled = _ref["default"],
    createGlobalStyle = _ref.createGlobalStyle,
    keyframes = _ref.keyframes,
    ThemeProvider = _ref.ThemeProvider,
    withTheme = _ref.withTheme,
    ServerStyleSheet = _ref.ServerStyleSheet,
    ThemeContext = _ref.ThemeContext;

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var border = border$1,
    borderRadius = borderRadius$1,
    color = color$1,
    compose = compose$1,
    flexbox = flexbox$1,
    grid = grid$1,
    gridColumn = gridColumn$1,
    layout = layout$1,
    shadow = shadow$1,
    space = space$1,
    typography = typography$1,
    style = style$1,
    system = system$1;
var css = css$1;
var all = compose(border, borderRadius, color, flexbox, layout, shadow, space, typography);
var layoutSpace = compose(layout, space);
export { ServerStyleSheet, ThemeProvider, all, border, borderRadius, color, compose, createGlobalStyle, css, flexbox, grid, gridColumn, keyframes, layout, layoutSpace, shadow, space, style, styled, system, typography, useTheme, withTheme };